import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
export function ExamBreak() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [breakTimeLeft, setBreakTimeLeft] = useState(45 * 60); // 45 minutes in seconds
  const [isManualContinue, setIsManualContinue] = useState(false);
  // Pass through the detailed answers from the first session
  const answers = location.state?.answers || {};
  const detailedAnswers = location.state?.detailedAnswers || [];
  // Log the verbal session answers for debugging
  useEffect(() => {
    console.log('Verbal session answers:', answers);
    console.log('Verbal session detailed answers:', detailedAnswers);
  }, [answers, detailedAnswers]);
  // Timer effect
  useEffect(() => {
    const timer = setInterval(() => {
      setBreakTimeLeft(prev => {
        if (prev <= 1 && !isManualContinue) {
          handleContinue();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [isManualContinue]);
  // Format time as MM:SS
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };
  // Handle continue to next session
  const handleContinue = () => {
    setIsManualContinue(true); // Prevent auto-continue
    navigate(`/online-denemeler/${id}/coz?session=sayisal`, {
      state: {
        previousAnswers: answers,
        previousDetailedAnswers: detailedAnswers
      }
    });
  };
  return <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-[#080808]" data-id="element-1630">
      <div className="max-w-2xl w-full space-y-8 text-center" data-id="element-1631">
        <h1 className="text-3xl font-bold text-purple-400" data-id="element-1632">Mola Zamanı</h1>
        <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1633">
          <div className="relative p-8 bg-black/90 rounded-xl" data-id="element-1634">
            <div className="space-y-6" data-id="element-1635">
              <div className="flex flex-col items-center" data-id="element-1636">
                <Clock className="w-16 h-16 text-purple-400 mb-4" data-id="element-1637" />
                <h2 className="text-xl font-medium mb-2" data-id="element-1638">
                  Sözel oturum tamamlandı
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-1639">
                  Sayısal Oturum için 45 dakikalık aranız başladı. Mola süresi
                  bittiğinde otomatik olarak sayısal oturuma geçilecektir.
                </p>
                <div className="text-4xl font-bold text-amber-400 mb-8" data-id="element-1640">
                  {formatTime(breakTimeLeft)}
                </div>
                <button onClick={handleContinue} className="flex items-center justify-center gap-2 px-8 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg text-white hover:opacity-90 transition-colors" data-id="element-1641">
                  Sayısal Oturuma Geç
                  <ArrowRight className="w-5 h-5" data-id="element-1642" />
                </button>
              </div>
              <div className="border-t border-gray-800 pt-4" data-id="element-1643">
                <h3 className="text-lg font-medium mb-4" data-id="element-1644">Sayısal Bölüm</h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1645">
                  <div className="border border-blue-500/30 rounded-lg p-4" data-id="element-1646">
                    <h4 className="font-medium text-blue-400 mb-2" data-id="element-1647">
                      Matematik
                    </h4>
                    <p className="text-gray-300" data-id="element-1648">20 soru, 40 dakika</p>
                  </div>
                  <div className="border border-emerald-500/30 rounded-lg p-4" data-id="element-1649">
                    <h4 className="font-medium text-emerald-400 mb-2" data-id="element-1650">
                      Fen Bilimleri
                    </h4>
                    <p className="text-gray-300" data-id="element-1651">20 soru, 40 dakika</p>
                  </div>
                </div>
              </div>
              <div className="text-sm text-gray-400" data-id="element-1652">
                <p data-id="element-1653">
                  Molayı uzatmak veya kısaltmak için "Sayısal Oturuma Geç"
                  butonuna tıklayabilirsiniz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}